import { memo } from 'react'

const Payments = memo(() => {
    return (
        <div className="mt-5">
            <h1 className="">campaigns / media-buying / Settings / Payments</h1>
        </div>
    )
})

export default Payments
